import axios from 'axios';
import Cookies from 'js-cookie';

export default async function callAPI({ url, method, data, token, serverToken, locationId, responseType, params = '', qrId }) {
  const tokens = Cookies.get('token');
  const locations = Cookies.get('locationId');
  const qr_id = Cookies.get('qrCodeId');
  let headers = {};

  if (serverToken) {
    headers = {
      Authorization: `Bearer ${tokens}`,
    };
  } else if (token && locationId) {
    headers = {
      locationId: `${locations}`,
      Authorization: `Bearer ${tokens}`,
    };
  } else if (qrId && locationId) {
    headers = {
      locationId: `${locations}`,
      qrid: qr_id,
    };
  }

  const response = await axios({
    url,
    params,
    responseType,
    method,
    data,
    headers,
  }).catch((err) => err.response);

  if (response?.status > 300) {
    const res = {
      error: true,
      message: response?.data?.errors,
      data: response?.data,
    };
    return res;
  }

  const { length } = Object.keys(response?.data);
  const res = {
    error: false,
    message: 'success',
    data: length > 1 || responseType ? response?.data : response?.data?.data,
  };

  return res;
}
